import { AppUser, UserStatus } from '../types';

const BASE_URL = '/api/admin/users';

export async function fetchAdminUsersApi(): Promise<AppUser[]> {
  const res = await fetch(BASE_URL);
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Error al obtener usuarios');
  return data.users || [];
}

export async function updateUserStatusApi(userId: string, status: UserStatus): Promise<void> {
  const res = await fetch(`${BASE_URL}/status`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, status }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Error al actualizar estado del usuario');
}

export async function saveUserDataApi(userId: string, userData: Partial<AppUser>): Promise<void> {
  const res = await fetch(`${BASE_URL}/save`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, userData }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Error al guardar datos del usuario');
}

export async function saveUserApi(user: Partial<AppUser>): Promise<void> {
  const userId = user.id || user.uid || `usr_${Date.now()}`;
  return saveUserDataApi(userId, user);
}
